import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { LoadingState } from '../components/LoadingState/LoadingState';

// Lazy-load pages for code-splitting
const Browse = lazy(() => import('../pages/Browse/Browse'));
const Detail = lazy(() => import('../pages/Detail/Detail'));
const NotFound = lazy(() => import('../pages/NotFound/NotFound'));

export default function AppRoutes() {
  return (
    <Suspense fallback={<LoadingState message="Loading…" />}>
      <Routes>
        <Route path="/" element={<Browse />} />
        <Route path="/video/:id" element={<Detail />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}
